import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationResponse } from './types';

export async function getOrganization(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}`;

  const response = await api.executeGetRequest<ObjectResponse<OrganizationResponse>>(url);

  return response.data;
}
